export default __webpack_public_path__ + "static/mediumHex-aa6ef90c0064d7df63d25df9f43a579d.jpg";